import React from 'react'

import BulkImport from './bulk-import'

const ProductCategoryImport = () => {
  return (
    <div>
      <BulkImport
        title={
          <span>
            Import Product Categories
          </span>
        }
        uploadPath='admin/product_categories/import'
        templatePath='admin/product_categories/import/template'
      >
        Import product category associations. This process will link products to categories.
        <ul>
          <li>The system will validate that both product_id and category_id exist.</li>
          <li>The category_id must be of type "product" to be valid.</li>
          <li>Duplicate associations will be ignored.</li>
          <li>Required columns: <code>product_id</code>, <code>category_id</code></li>
        </ul>
      </BulkImport>
    </div>
  )
}

export default ProductCategoryImport
